import { render, staticRenderFns } from "./CustomInvoiceView.vue?vue&type=template&id=cd05145a&"
import script from "./CustomInvoiceView.vue?vue&type=script&lang=js&"
export * from "./CustomInvoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports